module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_timra-22e29d96c41b7fadc08303b5e3e46467.png";